module.exports = __webpack_public_path__ + "assets/img/wzj.6e186d5a.png";